module.exports = __webpack_public_path__ + "static/1-1da27cc8bfb99f849d4d2e9c9d47dfb9.pdf";